import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import axios from "axios";
import PropTypes from "prop-types";
import { Dialog, Button, Image } from "hesus-ui-kit";
import ClipLoader from "react-spinners/ClipLoader";
import closeIcon from "@icons/ic-close-white.svg";
import AdminSearchBox from "./components/AdminSearchBox/PersonInChargeSearchBox";
import saleIcon from "@icons/ic-sales.svg";
import financeIcon from "@icons/ic-finance1.svg";
import studieIcon from "@icons/ic-studies.svg";
import productIcon from "@icons/ic-products1.svg";
import dispatchIcon from "@icons/ic-dispatch.svg";
import clientIcon from "@icons/ic-client.svg";
import UserInfo from "@utils/UserInfo";
import {
  HeaderWrapper,
  Title,
  ButtonWrapper,
  FormBody,
  OptionsWrapper,
  FlexRow,
  SectionContainer,
  CKGridRow,
} from "./PersonInChargeAddEdit.styled";

const PersonInChargeAddEdit = (props) => {
  const {
    t,
    entityId,
    entityType,
    data,
    onClose,
    setData,
    columnName,
    countryId,
  } = props;

  const [adminList, setAdminList] = useState([]);
  const [isPersonInChargeCreating, setIsPersonInChargeCreating] =
    useState(false);
  const [createPersonInChargeAPIError, setCreatePersonInChargeAPIError] =
    useState("");
  const [isAdminSuggestionsLoading, setAdminSuggestionsLoading] =
    useState(false);

  const [formData, setFormData] = useState({
    customerRelationship: data?.customerRelationship ?? null,
    finance: data?.finance ?? null,

    operations: data?.operations ?? null,
    products: data?.products ?? null,

    sales: data?.sales ?? null,

    studies: data?.studies ?? null,
  });

  let title = "";
  if (entityType === "company") title = t("COMPANY");
  else if (entityType === "site") title = t("SITE");
  else title = t("ENQUIRY");

  useEffect(() => {
    let url = `/general/search?limit=-1&countries=[${countryId}]&objectTypes=["admin"]&orderBy=asc`;
    getAdmins(url, "selectedDefault");
  }, []);

  const getAdmins = (url, type) => {
    setAdminSuggestionsLoading(true);
    axios
      .get(url)
      .then((response) => {
        setAdminList(response.data.admins);
      })
      .catch((error) => {
        if (window.debugMode) {
          console.error(
            "Error: an error occurred while fetching admins",
            error
          );
        }
        setAdminList([]);
        setAdminSuggestionsLoading(false);
      });
  };

  const onSubmit = () => {
    setIsPersonInChargeCreating(true);
    setCreatePersonInChargeAPIError("");
    axios
      .put(`/personsInCharge?${columnName}=${entityId}`, formData)
      .then((res) => {
        setData(res?.data);
        setIsPersonInChargeCreating(false);
        onClose();
      })
      .catch((error) => {
        // setIsCenterProductPriceCreating(false);
        // setCreateProductPriceAPIError(error.response?.data?.message ?? "");
        setIsPersonInChargeCreating(false);
        setCreatePersonInChargeAPIError(error.response?.data?.message ?? "");
      });
  };

  return (
    <Dialog>
      <div>
        <HeaderWrapper>
          <Title>
            {title + " #" + entityId + " - " + t("PERSON_IN_CHARGE")}
          </Title>
          <Button
            onClick={onClose}
            styles={{
              backgroundColor: "transparent",
              border: "none",
              height: "auto",
              padding: 0,
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Image src={closeIcon} alt="close meeting report popup" />
          </Button>
        </HeaderWrapper>
        <FormBody>
          <OptionsWrapper>
            <FlexRow>
              <SectionContainer>
                <div>
                  <CKGridRow>
                    <AdminSearchBox
                      adminList={adminList}
                      formData={formData}
                      setFormData={setFormData}
                      title="TEAM_SALES"
                      type="sales"
                      icon={saleIcon}
                    />
                    <AdminSearchBox
                      adminList={adminList}
                      formData={formData}
                      setFormData={setFormData}
                      title="TEAM_STUDIES"
                      type="studies"
                      icon={studieIcon}
                    />
                    <AdminSearchBox
                      adminList={adminList}
                      formData={formData}
                      setFormData={setFormData}
                      title="TEAM_OPERATIONS"
                      type="operations"
                      icon={dispatchIcon}
                    />
                    <AdminSearchBox
                      adminList={adminList}
                      formData={formData}
                      setFormData={setFormData}
                      title="TEAM_PRODUCTS"
                      type="products"
                      icon={productIcon}
                    />
                    <AdminSearchBox
                      adminList={adminList}
                      formData={formData}
                      setFormData={setFormData}
                      title="TEAM_FINANCE"
                      type="finance"
                      icon={financeIcon}
                    />
                    <AdminSearchBox
                      adminList={adminList}
                      formData={formData}
                      setFormData={setFormData}
                      title="TEAM_CUSTOMER_RELATIONSHIP"
                      type="customerRelationship"
                      icon={clientIcon}
                    />
                  </CKGridRow>
                </div>
              </SectionContainer>
            </FlexRow>
          </OptionsWrapper>
        </FormBody>
        <ButtonWrapper>
          {createPersonInChargeAPIError && (
            <div>{createPersonInChargeAPIError}</div>
          )}
          <Button
            styles={{
              color: "#333",
              background: "#fff",
              border: "1px solid #ccc",
              marginRight: "1rem",
              "&:hover": {
                backgroundColor: "#ccc",
              },
            }}
            onClick={onClose}
          >
            {t("CLOSE")}
          </Button>
          <Button
            styles={{
              color: "white",
              background: "#1BACE4",
              border: "1px solid #1BACE4",
              "&:hover": {
                backgroundColor: "#1589b6",
              },
            }}
            onClick={onSubmit}
          >
            <>
              {isPersonInChargeCreating && (
                <ClipLoader size={15} color="#fff" />
              )}
              {!isPersonInChargeCreating && t("SUBMIT")}
            </>
          </Button>
        </ButtonWrapper>
      </div>
    </Dialog>
  );
};

PersonInChargeAddEdit.propTypes = {
  t: PropTypes.func.isRequired,
  entityId: PropTypes.number.isRequired,
  entityType: PropTypes.string.isRequired,
  columnName: PropTypes.string.isRequired,
  setData: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.shape({}),
  countryId: PropTypes.number.isRequired,
};

PersonInChargeAddEdit.defaultProps = {
  data: [],
};

export default withTranslation()(PersonInChargeAddEdit);
